import { BottomNavigationAction as MUIBottomNavigationAction, Theme, useMediaQuery, useTheme } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC, MouseEventHandler, ReactNode } from 'react';
import { useResponsiveText } from '../../hooks';
import { innerText } from '../../util';

interface Props {
  'data-testid'?: string;
  disabled?: boolean;
  href?: string;
  icon?: ReactNode;
  key?: string | number;
  label?: ReactNode;
  onClick?: MouseEventHandler | undefined;
  sx?: SxProps<Theme>;
  value?: ReactNode;
}

export const BottomNavigationAction: FC<Props> = ({ label, sx, ...props }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const labelLength = innerText(label ?? '').length;

  const labelStyles = useResponsiveText('0.85rem', labelLength, {
    minFontSize: '0.7rem',
    maxFontSize: '1rem',
    textLengthThreshold: 8,
  });

  const iconSize = isSmallScreen ? '1.25rem' : '1.5rem';

  return (
    <MUIBottomNavigationAction
      showLabel={true}
      label={label}
      sx={{
        '&': {
          lineHeight: 'normal',
          textAlign: 'center',
          color: props.disabled ? theme.palette.action.disabled : theme.palette.action.active,
          minWidth: 0,
          padding: '6px 4px',
          flexShrink: 1,
        },
        '& .MuiBottomNavigationAction-label': {
          fontSize: labelStyles.fontSize,
          lineHeight: labelStyles.lineHeight,
          wordBreak: labelStyles.wordBreak,
          whiteSpace: labelStyles.whiteSpace,
          overflow: labelStyles.overflow,
          textOverflow: labelStyles.textOverflow,
          marginTop: '2px',
        },
        '& .MuiSvgIcon-root': {
          fontSize: iconSize,
        },
        ...sx,
      }}
      {...props}
    />
  );
};
